import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericApiService } from '@pm-ui/core-services';

import { AccountsEndpoints } from '../../config';
import {
  IChangePasswordVM,
  ILoginVM,
  IPageRequestVM,
  IResetPasswordRequestVM,
  IResetRequestVM,
  IUserVM
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  constructor(private genericApiService: GenericApiService) { }

  authenticateUser<T>(model: ILoginVM): Observable<HttpResponse<T>> {
    return this.genericApiService.post<T>(AccountsEndpoints.AuthenticateUser, model);
  }
  sendOTP<T>(UserId: any,token:any,DeviceId:any): Observable<HttpResponse<T>> {
    return this.genericApiService.SendOtpWithToken<T>(`${AccountsEndpoints.SendOTP}?UserId=${UserId}&DeviceId=${DeviceId}`,token);
  }
  ResendOTP<T>(UserId: any,token:any): Observable<HttpResponse<T>> {
    return this.genericApiService.SendOtpWithToken<T>(`${AccountsEndpoints.ResendOTP}?UserId=${UserId}`,token);
  }
  validateOTP<T>(UserId: any,otp:any): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(`${AccountsEndpoints.ValidateOTP}?UserId=${UserId}&OTP=${otp}`);
  }
  getUsers<T>(model: IPageRequestVM): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(`${AccountsEndpoints.GetUsers}?pageNumber=${model.pageNumber}&pageSize=${model.pageSize}`);
  }

  getUserById<T>(id: string): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(`${AccountsEndpoints.GetUserById}/${id}`);
  }

  createUser<T>(model: IUserVM): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AccountsEndpoints.CreateUser, model);
  }

  deleteUser<T>(id: string): Observable<HttpResponse<T>> {
    return this.genericApiService.delete(`${AccountsEndpoints.DeleteUser}/${id}`);
  }

  sendResetPasswordLink<T>(model: IResetRequestVM): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AccountsEndpoints.SendResetPasswordLink, model);
  }

  getUserFromResetToken<T>(resetToken: string): Observable<HttpResponse<T>> {
    return this.genericApiService.get(`${AccountsEndpoints.GetUserFromResetToken}/${resetToken}`);
  }

  resetPassword<T>(model: IResetPasswordRequestVM): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AccountsEndpoints.ResetPassword, model);
  }

  changePassword<T>(model: IChangePasswordVM): Observable<HttpResponse<T>> {
    return this.genericApiService.post(AccountsEndpoints.ChangePassword, model);
  }

  
  addUpdateUserSiteConnection<T>(reqModel:any): Observable<unknown>{        
    return this.genericApiService.post<T>(AccountsEndpoints.addUpdateUserSiteConnection, reqModel);
  }
}